<section [ngClass]="{'type-b scroll-gray': templateSuffix !== ''}">
  <h2 class="mb-3">
    <strong> Confirmación de tu auto </strong>
  </h2>

  <p class="text-question mb-3">
    ¿Estás seguro de proceder con tu renta del auto <strong> {{summary.carTitle}} {{summary.carModel}} </strong> con un
    pago
    inicial de <strong> {{ summary.initialPayment | currency }} </strong> ?
  </p>

  <div>

    <div class="title mb-3">
      <div class="title">
        <p class="brand"> {{ summary.carTitle }} </p>
        <p class="sub-brand"> {{ summary.carModel }} </p>
      </div>
    </div>


    <div class="img-container">
      <img [src]="summary.carImage" alt="" />
    </div>

    <p class="text-color" >
      Foto ilustrativa que no representa el color del auto seleccionado
    </p>


    <div class="row mb-3">

      <div class="col-12 col-lg-6">

        <table class="custom-table">
          <caption> </caption>
          <thead>
            <tr>
              <th scope="col"> Características del auto </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of details">
              <td class="item">
                <span> {{ item.desc }} </span>
                <span> {{ item.value }} </span>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <div class="col-12 col-lg-6">

        <table class="custom-table">
          <caption>  </caption>
          <thead>
            <tr>
              <th scope="col"> Detalles del auto </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="item">
                <span>Entidad de seguro y placas</span>
                <span><strong> {{ summary.state }} </strong></span>
              </td>

              <td class="item">
                <span>Renta adelantada</span>
                <span><strong> $ {{ summary.refund | number: '1.2-2' }} </strong></span>
              </td>

              <td class="item">
                <span>Producto</span>
                <span><strong> {{ summary.concept === 'afin' || summary.concept === 'rr' ? 'Rent2Buy' : summary.concept | titlecase}} </strong></span>
              </td>

              <td class="item">
                <span>Plazo</span>
                <span><strong> {{ summary.period }} meses </strong></span>
              </td>

              <td class="item">
                <span>Pago Inicial Total</span>
                <span><strong> $ {{ summary.initialPayment | number: '1.2-2' }} </strong></span>
              </td>

              <td class="item">
                <span> Renta Mensual </span>
                <span><strong> $ {{ summary.monthlyPayment | number: '1.2-2' }} </strong></span>
              </td>

              <td class="item">
                <span>Aseguradora</span>
                <span><strong> {{ summary.insurance }} </strong></span>
              </td>
            </tr>
          </tbody>
        </table>

      </div>


    </div>

    <div class="container-buttons">
      <button id="boton-cancelar-confirmar-opcion-{{data?.option}}{{templateSuffix !== '' ? '-b' : ''}}" class="mt-2 btn-cancel" mat-button mat-dialog-close>
        Cancelar
      </button>
      <button id="boton-continuar-confirmar-opcion-{{data?.option}}{{templateSuffix !== '' ? '-b' : ''}}" class="mt-2 btn-danger-custom" (click)="save()">
        Continuar
      </button>
    </div>

  </div>

</section>
